import messages from './i18n/messageloader';

export default {
  baseUrl: 'https://www.learn-atc.com',
  fallbackLocale: {
    'at': ['de'],
    'de': ['at', 'en'],
    'uk': ['en'],
    'ru': ['uk','en'],
    default: ['en']
  },
  messages,
  defaultLocale: 'en',
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false
}
